import {
  CM_BASE_URL,
  AMLS_REPORT_BASE_URL,
  CASE_CLOSURE_STATUSES
} from '../../pages/constants/cmConstants';

import { omit, toLower } from '../../util/lodashlike';
import { axios } from './common';

export const fetchMakerCheckerList = async (payload) => {
  const { currentPage, filters, pageSize } = payload;
  const params = {
    ...omit(filters, ['searchField', 'searchText']),
    offset: (currentPage - 1) * pageSize,
    limit: pageSize,
    status: CASE_CLOSURE_STATUSES.join(',')
  };

  if (filters.searchField && filters.searchText) {
    params[filters.searchField] = toLower(filters.searchText);
  }

  const url = `${CM_BASE_URL}/cases/all?checker-status=CHECK_NEEDED,APPROVED,REJECTED`;
  const res = await axios.get(url, { params });

  if (res.status !== 200) {
    throw new Error('Failed to fetch review list');
  }

  return res.data;
};

export const submitCheckerReview = async ({ caseId, reviewStatus, note }) => {
  const requestBody = {
    action: reviewStatus,
    note
  };
  const url = `${CM_BASE_URL}/cases/${caseId}/checkerReview`;
  return axios
    .put(url, requestBody)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const fetchGeneralMakerCheckerList = async (payload) => {
  const { currentPage, filters, pageSize } = payload;
  const params = {
    ...omit(filters, ['searchField', 'searchText']),
    offset: (currentPage - 1) * pageSize,
    limit: pageSize
  };

  if (filters.searchField && filters.searchText) {
    params[filters.searchField] = toLower(filters.searchText);
  }

  const url = `${AMLS_REPORT_BASE_URL}/tickets/all`;
  const res = await axios.get(url, { params });

  if (res.status !== 200) {
    throw new Error('Failed to fetch review list');
  }

  return res.data;
};

export const submitGeneralCheckerReview = async (payload) => {
  const url = `${AMLS_REPORT_BASE_URL}/tickets/update`;
  return axios
    .post(url, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
